/**
 * Requests for the User Management users list (PD-4063).
 *
 * Everything talks to Management::UsersController, so the paths are the page's
 * own — there is no separate API namespace.
 */

const getJson = async (path) => {
  const response = await fetch(path, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

const appendValues = (params, key, values) => {
  (values || []).forEach((value) => params.append(`${key}[]`, value));
};

const fetchUsers = async ({
  filters = {},
  page = 1,
  query = '',
  sortBy = null,
  sortOrder = null,
} = {}) => {
  const params = new URLSearchParams({ page });

  if (query) params.set('q', query);

  if (sortBy) {
    params.set('sort_by', sortBy);
    params.set('sort_order', sortOrder || 'ASC');
  }

  appendValues(params, 'account_ids', filters.accountIds);
  appendValues(params, 'permissions', filters.permissions);
  appendValues(params, 'job_roles', filters.jobRoles);

  const data = await getJson(`/management/users.json?${params}`);

  return {
    users: data.users,
    pagination: {
      page: data.pagination.page,
      perPage: data.pagination.per_page,
      totalItems: data.pagination.total_entries,
      totalPages: data.pagination.total_pages,
    },
  };
};

export const fetchFilterOptions = async () => {
  const data = await getJson('/management/users/filter_options.json');

  return {
    // Role names are their own value; job roles already arrive as label/value.
    permissions: data.permissions.map((name) => ({ label: name, value: name })),
    jobRoles: data.jobRoles,
  };
};

export const fetchAccounts = async (query) => {
  const params = new URLSearchParams();
  if (query) params.set('q', query);

  const suffix = params.toString() ? `?${params}` : '';
  const data = await getJson(`/management/users/accounts.json${suffix}`);

  return data.accounts;
};

export default fetchUsers;
